// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__14WSG","bigColWidth":"Table_bigColWidth__3p7g7","biggerColWidth":"Table_biggerColWidth__OBjue","row":"Table_row__32BWq","col":"Table_col__3GuaG"};